import React from "react";
import AuthEmailPassword from "./Component/AuthEmailPassword";
import NavUp from "../../../commons/NavUp";
import Title from "../../../pages/Login/Components/title/title";
import AuthFacebook from "./Component/AuthFacebook";
import AuthGmail from "./Component/AuthGmail";
import "../../../pages/Login/styles.css";
import { Link } from "react-router-dom";
import AddButton from "../../../commons/AddButton";

class Login_technician extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <NavUp />
        <div
          id="alertLoginTec"
          className="text-center alert alert-danger d-none"
          role="alert"
        ></div>
        <Title
          text1="Welcome to Denter. We're happy to have you onboard.
            Let's get you some work"
        />
        <AuthEmailPassword />
        <div className="text-center mt-2">
          <AuthFacebook />
        </div>
        <div className="text-center mt-2">
          <AuthGmail />
        </div>
        <div className="text-center mt-5 mb-5">
          <hr />
          <p className="d-inline text-muted">or</p> <hr />
        </div>
        <Link to="/createNewAccount">
          <AddButton text="Create a new account" />
        </Link>
      </React.Fragment>
    );
  }
}
export default Login_technician;
